import * as R from 'ramda';

import { USER_ROLES } from '../api/constants';
import defaultUserImage from '../static/imgs/default-user-image.png';

const { ADMIN, SUPER_ADMIN, SALES_AGENT } = USER_ROLES;

export const getAvatarUrl = userAvatar => userAvatar || defaultUserImage;

export const getCurrentUserId = () => localStorage.getItem('userId');

// Return active Users
export const filterUsers = users =>
  Object.keys(users).reduce((filteredUsers, id) =>
    (!users[id].isDeleted && users[id].isActivated && !users[id].isDefault)
      ? ({ ...filteredUsers, [id]: users[id] })
      : filteredUsers, {});

export const filterUsersWithoutCurrent = users => R.dissoc(localStorage.getItem('userId'), filterUsers(users));

export const checkIfCurrentUserAdmin = (users) => {
  const userId = localStorage.getItem('userId');
  return [ADMIN, SUPER_ADMIN].includes(R.pathOr('', [userId, 'role'], users));
};

export const checkIfCurrentUserSuperAdmin = (users) => {
  const userId = localStorage.getItem('userId');
  return [SUPER_ADMIN].includes(R.pathOr('', [userId, 'role'], users));
};

export const checkIfCurrentUserSalesAgent = (users) => {
  const userId = localStorage.getItem('userId');
  return [SALES_AGENT].includes(R.pathOr('', [userId, 'role'], users));
};



// WEBPACK FOOTER //
// ./src/utils/users.js